import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
}

export function SEO({
  title = "Majesty Hostel - Premium Student Accommodation in Koforidua, Ghana",
  description = "Experience royal living at Majesty Hostel - premium student accommodation near campus with 24/7 electricity, Starlink WiFi, maximum security, and affordable rates. Book your room today!",
  keywords = "student hostel Koforidua, student accommodation Ghana, hostel near campus, affordable student housing, Koforidua hostels, university accommodation, student rooms Ghana, hostel with WiFi, secure student housing",
  image = "https://majestyhostel.com/og-image.jpg",
  url = "https://majestyhostel.com",
  type = "website"
}: SEOProps) {
  const siteName = "Majesty Hostel";
  const twitterHandle = "@majestyhostel";

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Geo Tags */}
      <meta name="geo.region" content="GH-EP" />
      <meta name="geo.placename" content="Koforidua" />
      <meta name="geo.position" content="6.0891;-0.2595" />
      <meta name="ICBM" content="6.0891, -0.2595" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_GH" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      <meta property="twitter:site" content={twitterHandle} />
      <meta property="twitter:creator" content={twitterHandle} />

      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="Majesty Hostel" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
}
